/*
 * @Description: 日志中心 api
 * @Author: lidan
 * @Date: 2020-08-28 10:06:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-30 15:35:38
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi, e6BaseCarrier3Api } from "@/config/api";
const { host = "", E6_MS_TMS_REPORT_WEB = "" } = e6ModuleBaseDataApi;
const { E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6BaseCarrier3Api;
//********************* 日志中心 ****************** */

// 获取日志中心列表数据
export function findLogCenterByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/tms/operation/log/findByPage`,
    method: "post",
    data
  });
}

// 获取日志中心模块下拉数据
export function findFunctionDropDown() {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/tms/operation/log/findFunctionDropDown`,
    method: "get"
  });
}

// 获取日志来源下拉数据
export function getOperationPlatform() {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/tms/operation/log/getOperationPlatform`,
    method: "get"
  });
}

// 导出日志中心
export function exportLog(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_REPORT_WEB}/tms/operation/log/export`,
    method: "post",
    data
  });
}

// 用户类型查询下拉
export function getUserTypeList(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getUserTypeList`,
    method: "get",
    params
  });
}

// 根据用户类型获取用户下拉
export function getListByUserType(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getListByUserType`,
    method: "get",
    params
  });
}
